import React from 'react';
import { Box, Skeleton } from '@mui/material';

// Szary placeholder o kształcie AttendanceMobileRow, wyświetlany podczas ładowania danych z serwera
function AttendanceMobileRowSkeleton() {
    return (
        <Box sx={{ py: 1.25 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <Skeleton variant="circular" width={40} height={40} />
                <Box sx={{ flex: 1, minWidth: 0 }}>
                    <Skeleton variant="text" width="60%" height={24} />
                    <Skeleton variant="rounded" width="100%" height={10} sx={{ mt: 0.5, mb: 0.5 }} />
                    <Skeleton variant="text" width="35%" height={16} />
                </Box>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, flexShrink: 0 }}>
                    <Skeleton variant="text" width={36} height={20} />
                </Box>
            </Box>
        </Box>
    );
}

export default AttendanceMobileRowSkeleton;
